import axios from 'axios'
import config from '../config'

const User = {
    state: {
         userItems: [],
         userInfo: [],
         shops: [],
         AddUser: [],
         status: '',
         error: false,
         msg: ''
        
    },
    mutations: {
       fetchUser: (state, userItems) => (state.userItems  = userItems),
       userUpdateState: (state, status) =>(state.status = status),
       getUserInfo: (state, userInfo) => state.userInfo = userInfo,
       getUserShops: (state, shops) => state.shops = shops,
       ERROR: (state, error) => state.error = error,
       MSG: (state, msg) => state.msg = msg
    
      
    },
    actions: {
       async fetchUser({commit}, data ){
        await axios({
          method:'post',
          url: config.LOAD_USER_LIST,
          data: data
        }) 
        .then((result) => {
          commit('fetchUser', result.data.users)
        }).catch((err) => {
          console.log(err)
        });   
       },
       async updateUserStatus({commit}, data){
          await axios({
            method:'post',
            url: config.USER_UPDATE_STATUS,
            data: data
          })
          .then((result) => {
            commit('ERROR', result.data.error)
            commit('MSG', result.data.msg)
          }).catch((err) => {
            console.log(err);
          });
       },
      async AddUser({commit}, userForm){
        await axios({
          method:'post',
          url: config.ADD_USER,
          data: userForm
        })
        .then((result) => {
          commit('ERROR', result.data.error)
          commit('MSG', result.data.msg)
        }).catch((err) => {
          console.log(err);
        });
      },
      async updateUser({commit}, userUpdate){
        await axios({
          method:'post',
          url: config.USER_UPDATE,
          data: userUpdate
        })
        .then((result) => {
          commit('ERROR', result.data.error)
          commit('MSG', result.data.msg)
        }).catch((err) => {
          console.log(err);
        });
      },
      async fetchUserInfo({commit}, data) {
        await axios({
          method:'post',
          url: config.LOAD_USER_DETAIL,
          data: data
        })
        .then((result) => {
          commit('getUserInfo', result.data.user)
          commit('getUserShops', result.data.shops)
        }).catch((err) => {
          console.log(err);
        });
    },
  },
    getters: {
        getUser: state => state.userItems,        
        getAdd: state => state.changeAddUser,
        getUserDetail: state =>state.UserInfo,
        getTabs: state => state.tabsKey,
        getKey: state => state.key,
        getPageTotal: state => state.pageTotal,
        UserInfo: state => state.userInfo,
        UserShops: state => state.shops,
        getUserError: state => state.error,
        getUserMsg: state => state.msg

    }

}

export default User;